export default __webpack_public_path__ + "static/media/abstract03.d4eb62ed.webp";